// Questions d'angle avant la lettre (issue #165) : lecture défensive de la
// réponse de `generateLetterAnglesPrompt`. Une réponse illisible rend une liste
// vide, et la lettre s'écrit alors sans angle, comme avant : l'étape est une
// aide, elle ne bloque jamais.

export interface LetterAngleQuestion {
  /** `pourquoi`, `probleme`, `preuve` ou `manque` : identifiant technique. */
  id: string
  question: string
  /** Propositions cliquables tirées de l'offre et du CV (trois au plus). */
  options: string[]
}

/** Une réponse du candidat, telle qu'elle part dans le prompt de la lettre. */
export interface LetterAngle {
  question: string
  answer: string
}

export function parseLetterAngles(raw: string): LetterAngleQuestion[] {
  const cleaned = String(raw ?? '').replace(/```json|```/g, '').trim()
  const first = cleaned.indexOf('{')
  const last = cleaned.lastIndexOf('}')
  let obj: unknown
  try {
    obj = JSON.parse(first >= 0 && last > first ? cleaned.slice(first, last + 1) : cleaned)
  } catch {
    return []
  }
  const arr = (obj as { questions?: unknown })?.questions
  if (!Array.isArray(arr)) return []
  const out: LetterAngleQuestion[] = []
  for (const q of arr) {
    if (!q || typeof q !== 'object') continue
    const o = q as Record<string, unknown>
    const question = typeof o.question === 'string' ? o.question.trim() : ''
    if (!question) continue
    const options = Array.isArray(o.options)
      ? o.options.filter((x): x is string => typeof x === 'string' && x.trim() !== '').map((x) => x.trim()).slice(0, 3)
      : []
    out.push({ id: typeof o.id === 'string' && o.id.trim() ? o.id.trim() : `q${out.length + 1}`, question, options })
    if (out.length >= 4) break
  }
  return out
}

/** Les réponses non vides, prêtes pour `CoverLetterContext.angles`. */
export function anglesRemplis(questions: LetterAngleQuestion[], reponses: string[]): LetterAngle[] {
  return questions
    .map((q, i) => ({ question: q.question, answer: (reponses[i] ?? '').trim() }))
    .filter((a) => a.answer)
}
